import React, { useEffect } from 'react';
import { PageHero } from '../components/PageHero';
import { TrustStrip } from '../components/TrustStrip';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { FinalCta } from '../components/FinalCta';
import { ServiceCoverage } from '../components/service/ServiceCoverage';
import { ServiceDetails } from '../components/service/ServiceDetails';
import { ServiceFaqs } from '../components/service/ServiceFaqs';
import { RelatedServices } from '../components/service/RelatedServices';
import type { ServicePageContent } from '../types/servicePage';
type ServicePageProps = {
  page: ServicePageContent;
};
export function ServicePage({
  page
}: ServicePageProps) {
  useEffect(() => {
    document.title = `${page.title} in Las Vegas | Home Repair MD`;
  }, [page.title]);
  return <>
      <PageHero crumbs={[{
      label: 'Services',
      to: '/#services'
    }, {
      label: page.name
    }]} title={<>
            {page.title} <span className="text-brand" data-id="element-522" data-mp="39xkbf6kz0dix">in Las Vegas</span>
          </>} intro={page.intro} defaultService={page.serviceId} formTitle={`Free ${page.name.toLowerCase()} quote`} data-id="element-521" data-mp="3e0gv70m8yfog" />
      <TrustStrip data-id="element-523" data-mp="dzaboh6atik2" />
      <ServiceCoverage name={page.name} intro={page.coverageIntro} items={page.coverage} data-id="element-524" data-mp="iwtuludxyjic" />
      <ServiceDetails name={page.name} sections={page.sections} checklist={page.checklist} data-id="element-525" data-mp="nvdfrskpnr9n" />
      <WhyChooseUs serviceName={page.name} data-id="element-526" data-mp="supzw5k76k8j" />
      {page.faqs && page.faqs.length > 0 && <ServiceFaqs faqs={page.faqs} data-id="element-527" data-mp="ssnannqvcv4v" />}
      <RelatedServices slugs={page.related} data-id="element-528" data-mp="wvtj921geyei" />
      <FinalCta data-id="element-529" data-mp="wuifh280dqne" />
    </>;
}